import { WidgetConfig, WidgetElementType } from "@redotech/redo-model/widget";
import { StorefrontCoverageHtmlElement } from "../cart-app";

export function hasValidButtonSelectors(
  toggles: {
    redoHtmlElements: StorefrontCoverageHtmlElement[];
    widgetConfig?: WidgetConfig;
  }[],
): boolean {
  const usingWidgetConfigs = toggles.some(
    ({ redoHtmlElements, widgetConfig }) => !!widgetConfig,
  );

  if (!usingWidgetConfigs) {
    if (
      toggles.every(
        ({ redoHtmlElements, widgetConfig }) => redoHtmlElements.length === 0,
      )
    ) {
      return false;
    }
    return true;
  }

  const checkoutButtonElements = toggles.filter(
    ({ redoHtmlElements, widgetConfig }) => {
      return (
        widgetConfig?.elementType === WidgetElementType.BOTH_CHECKOUT_BUTTONS ||
        widgetConfig?.elementType ===
          WidgetElementType.COVERAGE_CHECKOUT_BUTTON ||
        widgetConfig?.elementType ===
          WidgetElementType.NON_COVERAGE_CHECKOUT_BUTTON
      );
    },
  );

  if (
    checkoutButtonElements.every(
      ({ redoHtmlElements, widgetConfig }) => redoHtmlElements.length === 0,
    )
  ) {
    return false;
  }

  return true;
}
